module.exports = __webpack_public_path__ + "static/scale-model-of-central-park-in-fremont-california-a16c844281852310718aadcfdef555e1.png";